var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`myh0${_vm.skinType + 1}_info_wr`},[_c('div',{staticClass:"left"},[_c('h2',{attrs:{"id":"biz_v_title02"}},[_vm._v(_vm._s(_vm.detail.userDetail.companyName))])]),_c('div',{staticClass:"right"}),_c('section',{attrs:{"id":"myh01_info_tb"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }